import deanFil from 'marketing-website/media/images/pages/pricing/deanfil@2x.jpg';
import reyElle from 'marketing-website/media/images/pages/pricing/reyelle@2x.jpg';
import rua from 'marketing-website/media/images/pages/pricing/rua@2x.jpg';
import yav from 'marketing-website/media/images/pages/pricing/yav@2x.jpg';
import zorast from 'marketing-website/media/images/pages/pricing/zorast@2x.jpg';

const assets = {
  deanFil: {
    alt: 'Two men looking at a print',
    src: deanFil,
    width: '100%',
  },
  reyElle: {
    alt: 'Two women looking at a laptop',
    src: reyElle,
    width: '100%',
  },
  rua: {
    alt: `Marvel's Office Dog`,
    src: rua,
    width: '100%',
  },
  yav: {
    alt: `Man sitting in a library`,
    src: yav,
    width: '100%',
  },
  zorast: {
    alt: `Man calling with customers`,
    src: zorast,
    width: '100%',
  },
};

export default assets;



// WEBPACK FOOTER //
// ./src/configs/pages/pricing/support.js